<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Account Managementment - Passwords</h4>
        <p>Use the fields below to enter up to 15 characters and click "Apply" to change or create the password.</p>
        <p>Note : Password cannot contain a space.</p>


        <el-form :model="From"
            :rules="rules"
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form noWrap" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Username:" prop="user">
                <el-select v-model="From.user" placeholder="Please select" style="width: 100%">
                    <el-option :label="userName.user" value="user" v-if="isUserShow"></el-option>
                    <el-option :label="userName.admin" value="admin" v-if="$G_DEVICE_CFG.userType === '1'"></el-option>
                </el-select>
            </el-form-item>
           <el-form-item label="Old Password:" prop="oldPass" >
                <el-input v-model="From.oldPass" type="password"></el-input>
            </el-form-item>
            <el-form-item label="New Password:" prop="newPass">
                <el-input v-model="From.newPass" type="password"></el-input>
            </el-form-item>
             <el-form-item label="Confirm Password:" prop="passAgain">
                <el-input v-model="From.passAgain" type="password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
                <el-button type="primary" @click="resetForm(From)">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import _logout from '@/util/logout'
import sizeof from '@/util/jsCharLength.js'

const userTypeName = {
    '0':'user',
    '1':'admin',
    '2':'super',
    '3':'debug'
}
export default {
  data() {
    return {
      loading: false,
      From: {
        user: "user",
        oldPass: "",
        newPass: "",
        passAgain: ""
      },
      userName:{
          user:'admin',
          admin:'super',
      },
      rules: {
        oldPass: [
          {
            required: true,
            message: "The password must not be empty!",
            trigger: "blur"
          },
          
        ],
        newPass: [
          {
            required: true,
            message: "The password must not be empty!",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
				let reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[\s\S]{8,30}$/;
				if(this.$isAis || this.$isTRUE)
				{ // AIS 因 客户要求 允许简单密码
					if(sizeof(value,'utf-8') > 30 || sizeof(value,'utf-8') < 1)
						callback(new Error("password cannot be longer than 30 byte"))
					else
						callback()
				}
				else
				{
					if (!reg.test(value)) {
					callback(
							new Error("wrong password! No less than 8 digits and must contain letters, numbers, and special characters.")
						)
					} else {
						callback()
					}
				}
			},
            trigger: "blur"
          }
        ],
        passAgain: [
          {
            required: true,
            message: "The password must not be empty!",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (value != this.From.newPass) {
                callback(
                  new Error(
                    "The two passwords are inconsistent, please modify!"
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
      isUserShow() {
        if(this.$G_DEVICE_CFG.area === 'GTD' || this.$G_DEVICE_CFG.area === 'TRUE')
            return false
        else
            return true
      }
  },
  methods: {
    init() {
      let postdata = {
        CmdType: "GET_PASSWORD"
      };
      axios.post("/boafrm/loginpassword", postdata).then(res => {
        let data = res.data;
    
        if (data && data != "" && data.ret == "0") {
            this.userName.user = data.userName || 'admin';
            this.userName.admin = data.adminName || 'super';
            if(this.$G_DEVICE_CFG.area === 'GTD' || this.$G_DEVICE_CFG.area === 'TRUE')
                this.From.user = 'admin'
            else
                this.From.user = 'user'
        }
      });
    },
    save() {
      let oldPassword = this.From.oldPass;
      let newpasswordones = this.From.newPass; 
      let newpasswordtwos = this.From.passAgain;
    
      this.$refs["forms"].validate(valid => {
        if (valid) {
          this.loading = true;
          this.ajaxhttp();
        }
      });
    },
    ajaxhttp() {
      var postdata = {
        CmdType: "SET_PASSWORD",
        userType: this.From.user,
        oldPassword: this.From.oldPass,
        newPassword: this.From.newPass
      };
      axios.post("/boafrm/loginpassword", postdata).then(res => {
        this.loading = false;
        var backdata = res.data;
        if (backdata.ret == "0") {
          let uType = cookie.get("userType")
          if (postdata.userType === userTypeName[cookie.get("userType")]) {
            this.$alert(
              "Password change successful please login again.",
              "Message",{
                lockScroll: false,
                type:'success'
              }
            ).then(() => {
              _logout()
            });
          } else {
            this.$message.success("Password change successful!");
          }
        } else if (backdata.ret == "-2") {
          this.$message.error("Modify failed! Original password error!");
        } else {
          this.$message.error(`Modify failed! Error message:${backdata.errorMsg}`);
        }
      });
    },
    resetForm(formName) {
      this.$refs["forms"].resetFields();
    }
  },
  created() {
    this.init();
  }
};
</script>
<style lang="scss" >
.fhv-centent {
  .noWrap {
    .el-form-item--mini .el-form-item__error {
      white-space: nowrap;
    }
  }
}
</style>




